import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

export function Dialog({
  open,
  onOpenChange,
  title,
  description,
  children,
  footer,
  maxWidth = "860px",
}) {
  useEffect(() => {
    if (!open) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onOpenChange(false);
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [open, onOpenChange]);

  if (!open || typeof document === "undefined") {
    return null;
  }

  return createPortal(
    <div
      className="ui-dialog-backdrop"
      role="presentation"
      onMouseDown={() => onOpenChange(false)}
    >
      <div
        className="ui-dialog-content"
        role="dialog"
        aria-modal="true"
        aria-label={title}
        style={{ maxWidth }}
        onMouseDown={(event) => event.stopPropagation()}
      >
        <div className="ui-dialog-header">
          <div>
            <div className="ui-dialog-title">{title}</div>
            {description ? <div className="ui-dialog-description">{description}</div> : null}
          </div>

          <button
            className="ui-dialog-close"
            type="button"
            aria-label="Bezárás"
            onClick={() => onOpenChange(false)}
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>

        <div className="ui-dialog-body">{children}</div>
        {footer ? <div className="ui-dialog-footer">{footer}</div> : null}
      </div>
    </div>,
    document.body
  );
}
